var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIztrivaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.36,20.73c0,1.83-0.11,3.27,2.18,3.27c2.29,0,9.18,0,10.91,0c1.73,0,2.18-0.97,2.18-3.27 c0-2.3,0-15.27,0-15.27H4.36C4.36,5.45,4.36,18.89,4.36,20.73z M14.18,8.73h2.18c0,0,0,7.76,0,9.82c0,2.06-0.15,2.18-1.09,2.18 c-0.94,0-1.09,0-1.09,0V8.73z M7.64,8.73h2.18v12c0,0-0.15,0-1.09,0c-0.94,0-1.09-0.12-1.09-2.18C7.64,16.49,7.64,8.73,7.64,8.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.36,1.09 16.36,0 7.64,0 7.64,1.09 2.18,1.09 2.18,3.27 21.82,3.27 21.82,1.09  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIztrivaneIcon);
export default __webpack_public_path__ + "static/media/iztrivane_icon.801ed41e.svg";
export { ForwardRef as ReactComponent };